import { format } from 'date-fns';

import { EMPTY_PLACEHOLDER } from './constants';
import { toDateOrNull } from './parse';
import type { DateInput } from './types';

/**
 * Day-and-month-and-year is the admin default, not ISO. Operators compare a
 * screenshot against the system they are watching; `05 Mar 2026` reads at a
 * glance, `2026-03-05` does not.
 */
const DEFAULT_DATE_PATTERN = 'd MMM yyyy';

/**
 * Formats a date for display. Returns `—` when the input is not a date.
 *
 * Not money, and deliberately never extended to amounts.
 */
export function formatDate(value: DateInput, pattern: string = DEFAULT_DATE_PATTERN): string {
  const date = toDateOrNull(value);
  return date === null ? EMPTY_PLACEHOLDER : format(date, pattern);
}
